import React from 'react';
import { DatePicker, MobileTimePicker } from '@mui/x-date-pickers';
import { Button } from '@mui/material';
import moment from 'moment';
import Tile from '../Tile/Tile';
import { withRouter } from '../../utils/NavigationWrapper';
import Constants from '../../constants/Constants';

const filterSpacingStyle = { width: '20%', marginRight: '2rem' };

const DateTimeFilter = (props) => (
  <Tile title="Filters" helpTag="date-time-filter">
    <div className="u-fx  u-fx-align-end">
      <DatePicker
        slotProps={{
          textField: () => ({
            'data-qa': 'qa-date-from',
            error: props.dateTimeErrorMessage,
          }),
          actionBar: {
            // The actions will be the same between desktop and mobile
            actions: ['cancel', 'accept'],
          },
        }}
        className="u-mr-half"
        closeOnSelect={false}
        style={filterSpacingStyle}
        label="Date from"
        value={props.dateTimeFromFilter}
        placeholder="Date from"
        maxDate={moment.utc().add(1, 'months').startOf('month')}
        onAccept={(dateTime) => props.onChangeDateTime('dateFromFilter', dateTime)}
        openTo={'year'}
        format={'YYYY-MM-DD'}
      />
      <MobileTimePicker
        slotProps={{
          textField: () => ({
            'data-qa': 'qa-time-from',
            error: props.dateTimeErrorMessage,
          }),
        }}
        className="u-mr-half"
        closeOnSelect={false}
        style={filterSpacingStyle}
        label="Time from"
        value={props.dateTimeFromFilter}
        onAccept={(dateTime) => props.onChangeDateTime('timeFromFilter', dateTime)}
        ampm={false}
      />
      <DatePicker
        slotProps={{
          textField: () => ({
            'data-qa': 'qa-date-to',
            error: props.dateTimeErrorMessage,
          }),
          actionBar: {
            // The actions will be the same between desktop and mobile
            actions: ['cancel', 'accept'],
          },
        }}
        className="u-mr-half"
        closeOnSelect={false}
        style={filterSpacingStyle}
        label="Date to"
        value={props.dateTimeToFilter}
        placeholder="Date to"
        maxDate={props.maxDate !== undefined ? props.maxDate : moment.utc()}
        onAccept={(dateTime) => props.onChangeDateTime('dateToFilter', dateTime)}
        openTo={'year'}
        format={'YYYY-MM-DD'}
      />
      <MobileTimePicker
        slotProps={{
          textField: () => ({
            'data-qa': 'qa-time-to',
            error: props.dateTimeErrorMessage,
          }),
        }}
        className="u-mr-half"
        label="Time to"
        value={props.dateTimeToFilter}
        onAccept={(dateTime) => props.onChangeDateTime('timeToFilter', dateTime)}
        ampm={false}
      />
    </div>
    {props.dateTimeErrorMessage ? (
      <div className="u-fx u-fx-align-end u-mt-full ">
        <p className="u-italic" style={{ color: Constants.COLORS.ERROR }}>
          {props.dateTimeErrorMessage}
        </p>
      </div>
    ) : null}
    <div className="u-mt-double u-fx u-fx-align-center">
      <Button
        variant="contained"
        label="Apply"
        color="primary"
        onClick={props.onApplyFilters}
        disabled={props.isFetching}
        data-qa="qa-apply-filters"
      >
        Apply
      </Button>
      {props.metadata && props.metadata.Message ? (
        <p className="u-ml-double u-italic" style={{ color: Constants.COLORS.WARNING }}>
          {props.metadata.Message}
        </p>
      ) : props.metadata && props.metadata.hasOwnProperty('HasData') && !props.metadata.HasData ? (
        <p className="u-ml-double u-italic" style={{ color: Constants.COLORS.WARNING }}>
          {Constants.ZERO_RESULTS}
        </p>
      ) : null}
      {props.metadata &&
      props.metadata.hasOwnProperty('HasMoreData') &&
      props.metadata.HasMoreData ? (
        <p className="u-ml-double u-italic" style={{ color: Constants.COLORS.WARNING }}>
          {Constants.MORE_THAN_CONFIGURED_RESULTS}
        </p>
      ) : null}
    </div>
  </Tile>
);

export default withRouter(DateTimeFilter);
